import React, {useState} from 'react';
import styled from 'styled-components';

const ViewMoreLessContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.625rem;
	align-self: stretch;
	cursor: pointer;
`;

const ViewMoreLessLabel = styled.p`
	display: flex;
	padding: 0 0.75rem;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	white-space: nowrap;
	color: var(--sky-comp-button-color-text-lowEmphasis-default, #0004db) !important;

	/* sky/comp/button/font/standard */
	font-size: 1rem;
	font-style: normal;
	font-weight: 500;
	line-height: 1.5rem;
	letter-spacing: 0.00938rem;
`;

const ViewMoreLessLine = styled.hr`
	border: 1px solid #d3d3df;
	width: 100%;
	transition: border-color 0.15s ease;

	${ViewMoreLessContainer}:hover & {
		border-color: var(--sky-comp-button-color-text-lowEmphasis-default, #0004db);
	}
`;

const ViewMoreLessContent = styled.div<{$expanded: boolean}>`
	display: grid;
	grid-template-rows: ${({$expanded}) => ($expanded ? '1fr' : '0fr')};
	transition: grid-template-rows 0.2s ease;

	> div {
		overflow: hidden;
	}
`;

type ViewMoreLessProps = {
	children: React.ReactNode;
	expandLabel?: string;
	collapseLabel?: string;
};

const ViewMoreLess = ({children, expandLabel = 'View More', collapseLabel = 'View Less'}: ViewMoreLessProps) => {
	const [isExpanded, setIsExpanded] = useState(false);

	return (
		<>
			<ViewMoreLessContainer onClick={() => setIsExpanded(prev => !prev)}>
				<ViewMoreLessLine />
				<ViewMoreLessLabel>{isExpanded ? collapseLabel : expandLabel}</ViewMoreLessLabel>
				<ViewMoreLessLine />
			</ViewMoreLessContainer>
			<ViewMoreLessContent $expanded={isExpanded}>
				<div>{children}</div>
			</ViewMoreLessContent>
		</>
	);
};

export default ViewMoreLess;
